import { Icon as BlueIcon, IconName } from '@blueprintjs/core';
import { Group, Stack, Text, Title } from '@mantine/core';
import {
  getIconsNormalColor,
  textNormalIndex,
  wrapSx,
} from '@services/mantine';
import { gridSx, pSx, stackSx } from './HelpMenu.styles';

export function HelpMenuSection(props: HelpMenuSectionProps) {
  const { icon, title, paragraph } = props;

  return (
    <Stack spacing={8} sx={wrapSx(stackSx)}>
      <Group spacing={8}>
        <BlueIcon icon={icon} color={getIconsNormalColor()} />
        <Title order={5} color={textNormalIndex}>
          {title}
        </Title>
      </Group>
      <Group sx={wrapSx(gridSx)} position="right">
        <Text sx={wrapSx(pSx)} size="sm" color={textNormalIndex} component="p">
          {paragraph}
        </Text>
      </Group>
    </Stack>
  );
}
interface HelpMenuSectionProps {
  icon: IconName;
  title: string;
  paragraph: JSX.Element;
}
